export const POC_CHATS = {
  directAB: '30000000-0000-4000-8000-0000000000ab',
  groupABCD: '30000000-0000-4000-8000-00000000abcd'
} as const;

export interface CallSummary {
  id: string;
  chat_id: string;
  type: 'AUDIO' | 'VIDEO';
  state: 'RINGING' | 'ACTIVE' | 'ENDED';
  created_at: string;
  participation_state: string;
}

export interface JoinResponse {
  wsUrl: string;
  token: string;
  callId: string;
  participationId: string;
  expiresInSeconds: number;
}

export class CallsApi {
  constructor(private readonly credential: string, private readonly baseUrl = '/api') {}

  async listCalls(): Promise<CallSummary[]> {
    const response = await this.request<{ calls: CallSummary[] }>('/v1/calls');
    return response.calls;
  }

  async createCall(chatId: string, type: 'AUDIO' | 'VIDEO'): Promise<{ callId: string }> {
    return this.request('/v1/calls', {
      method: 'POST',
      body: JSON.stringify({ chatId, type }),
      idempotencyKey: crypto.randomUUID()
    });
  }

  async join(callId: string): Promise<JoinResponse> {
    return this.request(`/v1/calls/${encodeURIComponent(callId)}/token`, {
      method: 'POST', body: '{}', idempotencyKey: crypto.randomUUID()
    });
  }

  async action(callId: string, action: 'decline' | 'leave' | 'end_for_all'): Promise<void> {
    await this.request(`/v1/calls/${encodeURIComponent(callId)}/actions`, {
      method: 'POST', body: JSON.stringify({ action }), idempotencyKey: crypto.randomUUID()
    });
  }

  private async request<T>(path: string, options: RequestInit & { idempotencyKey?: string } = {}): Promise<T> {
    const { idempotencyKey, ...requestOptions } = options;
    const response = await fetch(`${this.baseUrl}${path}`, {
      ...requestOptions,
      cache: 'no-store',
      credentials: 'omit',
      headers: {
        authorization: `Bearer ${this.credential}`,
        'content-type': 'application/json',
        ...(idempotencyKey ? { 'idempotency-key': idempotencyKey } : {}),
        ...requestOptions.headers
      }
    });
    const data = await response.json() as T & { error?: string; message?: string };
    if (!response.ok) throw new Error(data.message ?? data.error ?? `HTTP ${response.status}`);
    return data;
  }
}

